import React from 'react';
import Typography from '@mui/material/Typography';

import styles from './Title.module.css';

export default function Title({title, actions}) {
  return (
    <div className={styles.title}>
      <Typography variant="h1">{title}</Typography>
      <div>
        {actions}
      </div>
    </div>
  );
}
